import { Programme } from 'src/dao/core-dao'
import { useCancelActiveProgramme } from 'src/hook/use-cancel-active-programme'
import { useState } from 'react'

export interface CancelProgrammeDialogState {
  programmePendingCancel: Programme | null
  requestCancel: (programme: Programme) => void
  dialogProps: {
    isOpen: boolean
    onClose: () => void
    onDismiss: () => void
    isSubmitting: boolean
  }
}

export const useCancelProgrammeDialog = (): CancelProgrammeDialogState => {
  const [programmePendingCancel, setProgrammePendingCancel] = useState<Programme | null>(null)
  const cancelMutation = useCancelActiveProgramme()

  return {
    programmePendingCancel,
    requestCancel: setProgrammePendingCancel,
    dialogProps: {
      isOpen: programmePendingCancel !== null,
      onClose: () => setProgrammePendingCancel(null),
      onDismiss: () => {
        if (!programmePendingCancel) {
          return
        }
        const programme = programmePendingCancel
        cancelMutation.mutate({ programmeId: programme.id, programme }, { onSettled: () => setProgrammePendingCancel(null) })
      },
      isSubmitting: cancelMutation.isLoading,
    },
  }
}
